import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {ImportProductsConfig} from "../model/run-products.model";

@Injectable({
  providedIn: 'root'
})
export class RunProductsConfigService {// 5 minutes

  constructor(private http: HttpClient) {
  }

  getDefaultImportConfig() {
    return this.http.get<ImportProductsConfig>(`${this.baseUrl}/import`);
  }

  saveDefaultImportConfig(request: ImportProductsConfig) {
    return this.http.post<ImportProductsConfig>(`${this.baseUrl}/import`, request);
  }

  get baseUrl(): string {
    return environment.apiProductsHost + '/console/retailer-products/processing/config'
  }
}
